import React, { useState } from 'react'
import DaumPostcodeEmbed from 'react-daum-postcode'
import { Button, Checkbox, Col, Input, Radio, Row } from 'antd'
import styles from '../../styles/sales.module.scss'

const ProductBuyerComponent = ({
  orderInfo,
  setOrderInfo,
  handleChange,
  paymentTypeOption,
  paymentType,
  setPaymentType,
  selectOptions,
  // setSelectOptions,
  cashReceiptTypeItems,
}) => {
  const [isPostalCodeModalOpen, setIsPostalCodeModalOpen] = useState(false)

  /**
   * Post Code 입력하기 (다음 주소 api)
   */
  const handlePostCode = (data) => {
    let fullAddress = data.address
    let extraAddress = ''

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname
      }
      if (data.buildingName !== '') {
        extraAddress +=
          extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
    }

    if (fullAddress?.length > 0) {
      setOrderInfo({
        ...orderInfo,
        postalCode: data.zonecode,
        address: fullAddress,
      })
    }
    setIsPostalCodeModalOpen(false) // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  }

  return (
    <>
      {/* 받는 분 */}
      <div
        className={`${styles['order-component-each']}`}
        style={{
          marginTop: '0.5em',
        }}
      >
        <h3
          className={`${styles['order-each-title']}`}
          style={{
            padding: '3px 0 0',
          }}
        >
          받는 분<span className={`${styles['title-required']}`}>*</span>
        </h3>
        <Col className={`${styles['order-component-each-col']}`}>
          <div className={`${styles['order-component-each-detail']}`}>
            <Row
              align="top"
              justify={'space-between'}
              style={{ rowGap: '8px' }}
            >
              <Input
                // className={`address-input`}
                name="name"
                value={orderInfo.name}
                onChange={handleChange}
                placeholder="성함"
              />
            </Row>
          </div>
        </Col>
      </div>
      {/* 핸드폰 번호 */}
      <div className={`${styles['order-component-each']}`}>
        <h3
          className={`${styles['order-each-title']}`}
          style={{
            padding: '3px 0 0',
          }}
        >
          핸드폰 번호
          <span className={`${styles['title-required']}`}>*</span>
        </h3>
        <Col className={`${styles['order-component-each-col']}`}>
          <div className={`${styles['order-component-each-detail']}`}>
            <Row
              align="top"
              justify={'space-between'}
              style={{ rowGap: '8px' }}
            >
              <Input
                name="phone"
                value={orderInfo.phone}
                onChange={handleChange}
                placeholder="- 없이 입력"
              />
            </Row>
          </div>
        </Col>
      </div>
      {/* 배송지 */}
      <div className={`${styles['order-component-each']}`}>
        <div className={`${styles['daum-post-code-wrap']}`}>
          <Col id={`daum-post-code-wrap`}>
            {isPostalCodeModalOpen && (
              <div className={`${styles['order-create-daum-post-code-wrap']}`}>
                <Row
                  className={`${styles['order-create-daum-post-code-header-wrap']}`}
                  justify="space-between"
                  align="middle"
                  wrap={false}
                >
                  <div>주소 검색</div>
                  <img
                    className={`${styles['order-create-daum-post-code-header-close-icon']}`}
                    src={`${process.env.REACT_APP_HOST}/assets/icon/sales/close-icon.png`}
                    onClick={() => setIsPostalCodeModalOpen(false)}
                  />
                </Row>
                <div style={{ border: 'solid 1px #707070' }}>
                  <DaumPostcodeEmbed
                    style={{
                      height: '500px',
                    }}
                    submitMode={false}
                    onComplete={handlePostCode}
                  />
                </div>
              </div>
            )}
          </Col>
        </div>
        <h3
          className={`${styles['order-each-title']}`}
          style={{
            padding: '3px 0 0',
          }}
        >
          배송지
          <span className={`${styles['title-required']}`}>*</span>
        </h3>
        <Col className={`${styles['order-component-each-col']}`}>
          <div className={`${styles['order-component-each-detail']}`}>
            <Row
              align="top"
              justify={'space-between'}
              style={{ rowGap: '8px' }}
            >
              <Row
                align="middle"
                wrap={false}
                style={{
                  width: '100%',
                  gap: '1rem',
                }}
              >
                <Input
                  name="postalCode"
                  value={orderInfo.postalCode}
                  onChange={handleChange}
                  placeholder="우편번호"
                />
                <Button
                  className={`${styles['order-create-postal-code-search-btn']}`}
                  onClick={() => setIsPostalCodeModalOpen(true)}
                >
                  우편번호 검색
                </Button>
              </Row>
              <Input
                name="address"
                value={orderInfo.address}
                onChange={handleChange}
                placeholder="기본주소"
                style={{ marginTop: 14, marginBottom: 14 }}
              />
              <Input
                name="addressDetail"
                value={orderInfo.addressDetail}
                onChange={handleChange}
                placeholder="상세주소"
              />
            </Row>
          </div>
        </Col>
      </div>
      {/* 배송 요청사항 */}
      <div className={`${styles['order-component-each']}`}>
        <h3
          className={`${styles['order-each-title']}`}
          style={{
            padding: '3px 0 0',
          }}
        >
          배송 요청사항
        </h3>
        <Col className={`${styles['order-component-each-col']}`}>
          <div className={`${styles['order-component-each-detail']}`}>
            <Row
              align="top"
              justify={'space-between'}
              style={{ rowGap: '8px' }}
            >
              <Input.TextArea
                // className="order-create-address-request"
                name="addressRequest"
                value={orderInfo.addressRequest}
                onChange={handleChange}
                placeholder="배송 시 요청 사항을 입력해주세요"
              />
            </Row>
          </div>
        </Col>
      </div>
      {/* 결제 타입 */}
      <div className={`${styles['order-component-each']}`}>
        <div className={`${styles['order-component-each-detail']}`}>
          <h4 className={`order-each-detail-title`}>결제 타입</h4>
          <Radio.Group
            // className="order-create-select-cash-receipt-type"
            options={paymentTypeOption}
            name="payment_type"
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
          />
        </div>
      </div>
      {paymentType === 'deposit' && (
        <>
          {/* 입금자명 */}
          <div className={`${styles['order-component-each']}`}>
            <h3
              className={`${styles['order-each-title']}`}
              style={{
                padding: '3px 0 0',
              }}
            >
              입금자명
              <span className={`${styles['title-required']}`}>*</span>
            </h3>
            <Col className={`${styles['order-component-each-col']}`}>
              <div className={`${styles['order-component-each-detail']}`}>
                <Row
                  align="top"
                  justify={'space-between'}
                  style={{ rowGap: '8px' }}
                >
                  <Input
                    name="depositName"
                    value={orderInfo.depositName}
                    onChange={handleChange}
                    placeholder="입금자명"
                  />
                  <Col flex="none">
                    <Checkbox
                      // className="order-create-select-deposit-name"
                      name="sameDepositName"
                      value={true}
                      checked={selectOptions.sameDepositName}
                      onChange={handleChange}
                    >
                      <p>받는 분과 동일</p>
                    </Checkbox>
                  </Col>
                </Row>
              </div>
            </Col>
          </div>
          {/* 현금영수증 */}
          <div
            className={`${styles['order-component-each']}`}
            style={{
              borderBottom: 'solid 1px #ced4da',
              paddingBottom: '1.5rem',
            }}
          >
            <h3
              className={`${styles['order-each-title']}`}
              style={{
                padding: '3px 0 0',
              }}
            >
              현금영수증
            </h3>
            <Col className={`${styles['order-component-each-col']}`}>
              <div className={`${styles['order-component-each-detail']}`}>
                <Row
                  align="top"
                  justify={'space-between'}
                  style={{ rowGap: '8px' }}
                >
                  <span className={`gray-font`}>
                    * 먼저 언급하지 말고 고객 요청 시에만 발행할 것
                  </span>
                  <Radio.Group
                    // className="order-create-select-cash-receipt-type"
                    options={cashReceiptTypeItems}
                    name="cashReceiptType"
                    value={selectOptions.cashReceiptType}
                    onChange={handleChange}
                  />
                  <Row
                    align="middle"
                    wrap={false}
                    style={{
                      gap: '1rem',
                      width: '100%',
                    }}
                  >
                    <label
                      // className="order-create-cash-receipt-phone-label"
                      style={{
                        width: 'fit-content',
                        minWidth: 'fit-content',
                      }}
                    >
                      휴대폰 번호
                    </label>
                    <Input
                      name="cashReceiptPhone"
                      style={{
                        width: '100%',
                      }}
                      value={orderInfo.cashReceiptPhone}
                      onChange={handleChange}
                      placeholder="- 없이 입력"
                      disabled={selectOptions.cashReceiptType === null}
                    />
                  </Row>
                </Row>
              </div>
            </Col>
          </div>
        </>
      )}
    </>
  )
}
export default ProductBuyerComponent
